var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container--narrow"},[_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" "+_vm._s(_vm.$i18n.t('alertText'))+" ")]),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.replace({ name: 'membershipCard' })}}},[_vm._v(" "+_vm._s(_vm.$i18n.t('buttonText'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }